export const CATALOGUES_ROOT = 'catalogues-root';
